import { GET_INSPIRED_WITH_PROMPT } from '../constants/analytics-events/user-page-events';
import { FIRST_TIME_USER_PROMPTS } from '../constants/user-card-constants';
import { track } from './analytics-util';

export const getRandomPrompt = ({ isFirstCard }) => {
  track(GET_INSPIRED_WITH_PROMPT, { isFirstCard });
  const random = Math.floor(Math.random() * FIRST_TIME_USER_PROMPTS.length);
  return FIRST_TIME_USER_PROMPTS[random];
};
